import { Filtri_Scadenze } from '../Models/Filtri_Scadenze';
import { Subscription } from 'rxjs';
import { ApiRestService } from '../_services/api-rest.service';
import { ScadenzeStoreService } from '../_services/scadenze-store.service';
import { Component, OnInit } from '@angular/core';
import { CalendarEventAction } from 'angular-calendar';
import { CalendarEvent } from 'calendar-utils';
import { Scadenza } from '../Models/Scadenza';
import {EditScadenzaComponent} from "../edit-scadenza/edit-scadenza.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Permission} from "../../Login/_guards/Permission";
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-Scadenzario',
  templateUrl: './Scadenzario.component.html'
})
export class ScadenzarioComponent implements OnInit {
  environment = environment;
  subscriptions: Subscription = new Subscription();
  filtro: Filtri_Scadenze = {chiuso: 0, anno: undefined, mese: undefined};
  scadenze: Scadenza[] = [];
  collectionSize: number = 0;
  events: CalendarEvent[] = [];
  Stampe: any[];
  actions(): CalendarEventAction[] {
    if(!this.permission.isPermitted('gestione-scadenzario'))
      return [];
    return [
      {
        label: '<span class="badge badge-info ml-1"><i class="ti-pencil"></i></span>',
        a11yLabel: 'Edit',
        onClick: ({event}: { event: CalendarEvent }): void => {
          this.EditButton(event)
        },
      },
      {
        label: '<span class="badge badge-danger ml-1"><i class="ti-trash"></i></span>',
        a11yLabel: 'Delete',
        onClick: ({event}: { event: CalendarEvent }): void => {
          this.DeleteButton(event)
        },
      },
    ];
  }
  AddButton() {
      this.scadenzeStore.updateScadenzaSelezionata(new Scadenza());
      const editmodal = this.modalService.open(EditScadenzaComponent, {
        centered: true,
        backdrop: 'static',
        size: 'xl',
      });
      (<EditScadenzaComponent>editmodal.componentInstance).IsModal = true;
      (<EditScadenzaComponent>editmodal.componentInstance).added.subscribe(data=>{this.scadenzeStore.getScadenze(this.filtro);});
      (<EditScadenzaComponent>editmodal.componentInstance).updated.subscribe(data=> {});
  }
  EditButton(event) {
    this.scadenzeStore.updateScadenzaSelezionata(this.scadenze.find(x => x.id == event.id));
    const editmodal = this.modalService.open(EditScadenzaComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<EditScadenzaComponent>editmodal.componentInstance).IsModal = true;
    (<EditScadenzaComponent>editmodal.componentInstance).added.subscribe(data=>{});
    (<EditScadenzaComponent>editmodal.componentInstance).updated.subscribe(data=> {this.scadenzeStore.getScadenze(this.filtro);});
  }
  DeleteButton(event) {
    if(confirm("Sei sicuro di voler eliminare questo elemento? ")){
      this.ApiRestService.deleteScadenza(event).subscribe(data => {
        this.scadenzeStore.getScadenze(this.filtro);
      });
    }
  }

  constructor(
    private scadenzeStore: ScadenzeStoreService,
    private ApiRestService: ApiRestService,
    private modalService: NgbModal,
    public permission: Permission
  ) { }

  ngOnInit() {
    this.DateChanged(new Date());
    this.subscriptions.add(this.scadenzeStore.$scadenze.subscribe(data => {
      if (data && data != null) {
        this.scadenze = data.data;
        this.collectionSize = data.total;
        this.Stampe = data.stampe;
        this.events = this.Scadenze_To_Eventi(data.data);
      }
    }));
  }
  DateChanged(value: Date) {
    if (this.filtro.anno == value.getFullYear() && this.filtro.mese == value.getMonth() + 1)
      return;
    this.filtro.anno = value.getFullYear();
    this.filtro.mese = value.getMonth()+1;
    this.scadenzeStore.getScadenze(this.filtro);
  }
  Scadenze_To_Eventi(data: Scadenza[]): CalendarEvent[] {
    const Eventi: CalendarEvent[] = [];
    data.forEach(element => {
      Eventi.push(this.Scadenza_To_Event(element, this.actions()));
    });
    return Eventi;
  }
  public Scadenza_To_Event = (scadenza: Scadenza, actions?: CalendarEventAction[]): CalendarEvent => {
    return {
      start: new Date(scadenza.data_inizio_prevista),
      end: new Date(scadenza.data_fine_prevista),
      title: scadenza.nome,
      actions: actions,
      color: {
        primary: '#1e90ff',
        secondary: '#D1E8FF'
      },
      id: scadenza.id,
    }
  }

}
